import { createActionLayout } from '@malesia/react-components/dist/src/components/Table/columns/actionsColumn/actionLayout';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const editCustomer = createActionLayout({
    text: (
        <FormattedMessage
            id='front-app/CustomerListPage:editTitle'
            defaultMessage='Edit customer'
        />
    ),
    iconName: 'edit',
});
